var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.count),function(index){return _c('b-col',{key:index,attrs:{"md":"6","lg":"3"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('card-content-loader')],1)],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }